import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import StackQualification from "@/pages/StackQualification";

export const Route = createFileRoute("/stack-check/$token")({
  head: ({ params }) => seoHead(`/stack-check/${params.token}`),
  component: StackQualification,
});
